import {agreementTypes, feeAgreementsTypes} from "@/constants/agreement-constants";

export const getAgreementTypes = () => {
    let array = [];
    Object.keys(agreementTypes).forEach(function(key) {
        array.push({
            value: key,
            name: agreementTypes[key]
        });
    });
    return array;
};

export const isFeeAgreementType = (agreementType) => {
    return feeAgreementsTypes.includes(agreementType);
};

export const getAgreementTypeByKey = (agreementTypeKey) => (agreementTypes[agreementTypeKey]);